export default "__VITE_PUBLIC_ASSET__4f3d4662__"